import { render, staticRenderFns } from "./videoManager.vue?vue&type=template&id=81e12f46&scoped=true&"
import script from "./videoManager.vue?vue&type=script&lang=js&"
export * from "./videoManager.vue?vue&type=script&lang=js&"
import style0 from "./videoManager.vue?vue&type=style&index=0&id=81e12f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e12f46",
  null
  
)

component.options.__file = "videoManager.vue"
export default component.exports